import { CurrentUserInterface } from '../model/types';
import { useMemo } from 'react';
import { CurrentUser } from '../model/CurrentUser';
import { useGetCurrentUser } from '@/shared/api/generated/current-user';
import { AnonymousUser } from '../model/AnonymousUser';

type ReturnValue = {
  isLoading: boolean;
  user: CurrentUserInterface | null;
};

const queryOptions = {
  query: {
    staleTime: 30 * 60 * 1000, // 30 minutes
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    retry: false,
  },
};

export const useUser = (): ReturnValue => {
  const { data: userData, isLoading } = useGetCurrentUser(queryOptions);

  const user = useMemo(() => {
    if (!userData) {
      return null;
    }

    if (!userData.id) {
      return new AnonymousUser();
    }

    return new CurrentUser(userData);
  }, [userData]);

  return { user, isLoading };
};
